var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.994 1.667c3.885 0 7.089 3.098 7.089 6.931 0 1.932-.703 3.725-1.86 5.245a18.387 18.387 0 0 1-4.617 4.284c-.405.265-.77.285-1.215 0a18.033 18.033 0 0 1-4.616-4.284c-1.157-1.52-1.859-3.313-1.859-5.245 0-3.833 3.203-6.931 7.078-6.931zm0 4.814A2.345 2.345 0 0 0 7.66 8.814c0 1.284 1.048 2.294 2.333 2.294 1.286 0 2.344-1.01 2.344-2.294 0-1.274-1.058-2.333-2.344-2.333z",
    fill: "#4CA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9e6631b2b5fddec0e4ceafe6e037ebbf.svg";
export { ForwardRef as ReactComponent };